export function getTreatmentName(treatments, treatment_id) {
  if (!treatment_id) return 'All treatments'
  let treatment = treatments.find(item => item.id === treatment_id)
  return treatment ? treatment.name : null
}

export function getTreatmentStatus(treatments, treatment_id) {
  if (!treatment_id) {
    return `${treatments.length} ${treatments.length === 1 ? 'treatment' : 'treatments'} selected`
  }

  let treatment = treatments.find(item => item.id === treatment_id)
  return treatment ? treatment.status_name : '\u00A0'
}
